import MyAlgoConnect from '@randlabs/myalgo-connect';
export default MyAlgoConnect;
//# sourceMappingURL=ALGO_MyAlgoConnect.js.map
